import React, { useState } from "react";
import { AiFillBackward } from "react-icons/ai";
import { Link } from "react-router-dom";
import {
  useAddledgerMutation,
  useGetAllLedgerQuery,
} from "../../features/api/ledgerApi";
import { toast } from "react-toastify";

const CreateLedger = () => {
  const [ledgerName, setLedgerName] = useState("");
  const [ledger_tag, setTag] = useState(null);

  const [addNewLedger] = useAddledgerMutation();

  const ledgerTag = ["D", "S"];

  const handleCreate = async (e) => {
    e.preventDefault();
    const newLedger = { ledgerName: ledgerName, ledger_tag: ledger_tag };
    try {
      const response = await addNewLedger(newLedger);
      if (response) {
        toast.success("Added Success...!!!");
      }
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-2xl">Create Ledger</h1>
        <Link
          to="/dashboard/ledger-list"
          className="bg-blue-500 px-2 py-1 rounded text-white flex items-center gap-x-1"
        >
          <AiFillBackward /> Ledger List{" "}
        </Link>
      </div>
      <div>
        <form className=" grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div className="flex flex-col gap-1">
            <label>Ledger Name:</label>
            <input
              type="text"
              value={ledgerName}
              onChange={(e) => setLedgerName(e.target.value)}
              className="border h-8 pl-1"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label>Ledger Tag</label>
            <select
              onChange={(e) => setTag(e.target.value)}
              className="border h-8 pl-1"
            >
              <option>--select--</option>
              {ledgerTag?.map((tag, index) => (
                <option key={index} value={tag}>
                  {tag == "D" ? "Dealer" : "Supplier"}
                </option>
              ))}
            </select>
          </div>
        </form>
        <button
          onClick={handleCreate}
          className="bg-green-500 text-white font-bold px-4 py-1 mt-8 rounded"
        >
          Create
        </button>
      </div>
    </div>
  );
};

export default CreateLedger;